import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RefLink, RefLinkType} from '@twpub/core/models/ref-link';
import {ConceptSelection} from '@twpub/core/models';
import { NgClass } from '@angular/common';
import {RouterLink} from '@angular/router';
import {MatTooltip} from '@angular/material/tooltip';
import {InternalLinkRenderComponent} from '../internal-link-render/internal-link-render.component';

@Component({
  selector: 'pub-link-render',
  templateUrl: './link-render.component.html',
  standalone: true,
  imports: [NgClass, RouterLink, MatTooltip, InternalLinkRenderComponent]
})
export class LinkRenderComponent {
  @Input() refLink!: RefLink;
  @Input() text: string = '';

  @Output() conceptSelected = new EventEmitter<ConceptSelection>();

  selectConcept(selection: ConceptSelection) {
    this.conceptSelected.emit(selection);
  }

  protected readonly RefLinkType = RefLinkType;
}
